export const ProcessChargesMixin = {
    methods: {
        $_actionParameterCellRenderer(params, type, recalculateFn, fetchDataFn) {
            const {
                orderReference,
                shipmentRef,
                stopRef,
                tripReference,
                rateGroupNameCharges,
                rateGroupNameCosts,
                customerInvoiceId,
                teamMemberInvoiceId
            } = params.data;

            return {
                ...params.data,
                type,
                enableRecalculate:
                    !rateGroupNameCharges || !rateGroupNameCosts || customerInvoiceId > 0 || teamMemberInvoiceId > 0,
                reference: orderReference || shipmentRef || stopRef || tripReference,
                triggerRecalculate: recalculateFn,
                fetchData: fetchDataFn,

            };
        },
        $_servicePackageCellRenderer(params, type, recalculateFn) {
            const {
                orderReference,
                shipmentRef,
                stopRef,
                tripReference,
                rateGroupNameCharges,
                rateGroupNameCosts,
                customerInvoiceId,
                teamMemberInvoiceId,
                rateGroupCostId,
                rateGroupChargeId
            } = params.data;

            return {
                ...params.data,
                type,
                selectedRateGroupId: rateGroupCostId || rateGroupChargeId,
                servicePackageName: rateGroupNameCosts || rateGroupNameCharges,
                enableRecalculate:
                    !rateGroupNameCharges || !rateGroupNameCosts || customerInvoiceId > 0 || teamMemberInvoiceId > 0,
                reference: orderReference || shipmentRef || stopRef || tripReference,
                triggerRecalculate: recalculateFn
            };
        }
    }
};
